import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';
import { Vector } from 'matter';

export class EffectLineObject {
  private _scene: Game = Game.current;

  private _line: Phaser.GameObjects.Line;
  private _from: Vector;
  private _to: Vector;

  constructor(from: Vector, to: Vector) {
    this._from = from;
    this._to = to;

    this._line = this._scene.add.line(0, 0, from.x, from.y, from.x, from.y, 0xD3D3D3)
      .setOrigin(0.5)
      .setLineWidth(2)
      .setDepth(DEPTH.CARD_EFFECT);

    this.animateDrawLine();
  }

  private animateDrawLine() {
    const distance = Phaser.Math.Distance.Between(
      this._from.x, this._from.y, 
      this._to.x, this._to.y
    );
    const angle = Phaser.Math.Angle.Between(
      this._from.x, this._from.y, 
      this._to.x, this._to.y
    );

    this._scene.tweens.add({
      targets: { progress: 0 },
      progress: 1,
      duration: 350,
      ease: 'Quad.easeInOut',
      onUpdate: (tween: any) => {
        const value = tween.getValue();

        const currentEndPoint = {
          x: this._from.x + Math.cos(angle) * distance * value,
          y: this._from.y + Math.sin(angle) * distance * value
        };

        this._line.setTo(
          this._from.x, this._from.y,
          currentEndPoint.x, currentEndPoint.y
        );

        const startColor = 0xFFFFFF;
        const endColor = 0xD3D3D3;

        const currentColor = Phaser.Display.Color.Interpolate.ColorWithColor(
          Phaser.Display.Color.ValueToColor(startColor),
          Phaser.Display.Color.ValueToColor(endColor),
          1,
          value
        );

        this._line.setStrokeStyle(2, Phaser.Display.Color.GetColor(currentColor.r, currentColor.g, currentColor.b));
      },
      onComplete: () => {
        const impactCircle = this._scene.add.circle(this._to.x, this._to.y, 5, 0x00DDFF, 1)
          .setDepth(DEPTH.CARD_EFFECT + 1);

        this._scene.tweens.add({
          targets: impactCircle,
          scale: 3,
          alpha: 0,
          duration: 400,
          ease: 'Cubic.easeOut',
          onComplete: () => {
            impactCircle.destroy();
          }
        });

        this.animateFadeOut();
      }
    });
  }

  private animateFadeOut() {
    const distance = Phaser.Math.Distance.Between(
      this._from.x, this._from.y, 
      this._to.x, this._to.y
    );

    this._scene.tweens.add({
      targets: { progress: 0 },
      progress: 1,
      duration: 350,
      ease: 'Quad.easeInOut',
      onUpdate: (tween: any) => {
        const value = tween.getValue();

        const angle = Phaser.Math.Angle.Between(
          this._from.x, this._from.y, 
          this._to.x, this._to.y
        );

        const maskPosition = {
          x: this._from.x + Math.cos(angle) * distance * value,
          y: this._from.y + Math.sin(angle) * distance * value
        };

        this._line.setTo(
          maskPosition.x, maskPosition.y,
          this._to.x, this._to.y
        );
      },
      onComplete: () => {
        this.destroy();
      }
    });
  }

  public destroy() {
    if (this._line) this._line.destroy();
  }
}